module.exports = __webpack_public_path__ + "static/media/store_information_block_option_2.fb98646f.webp";